import { render, staticRenderFns } from "./PageFormItem.vue?vue&type=template&id=1b2128ae&scoped=true&"
import script from "./PageFormItem.vue?vue&type=script&lang=js&"
export * from "./PageFormItem.vue?vue&type=script&lang=js&"
import style0 from "./PageFormItem.vue?vue&type=style&index=0&id=1b2128ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2128ae",
  null
  
)

export default component.exports